import React, { useState } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import { s3baseUrl } from "src/config/config";
import { helping_video_Category_listing_api } from "src/DAL/HelpingVideos/AdminHelpingVideosCategory";

export default function HelpingVideosCategory() {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [videosCategory, setVideosCategory] = useState([]);
  const programsList = async () => {
    let postData = {
      search: "",
      type: 2,
    };
    const result = await helping_video_Category_listing_api(postData);
    if (result.code == 200) {
      setVideosCategory(result.helping_video_categories);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  useEffect(() => {
    programsList();
  }, []);

  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-12 col-sm-12">
          <h2>Helping videos Category</h2>
        </div>

        {videosCategory.map((value, index) => {
          return (
            <div className="col-lg-4 col-md-4 col-sm-12 mb-4" key={index}>
              <div
                className="card mt-4 pods-cards-shadow cursor h-100"
                onClick={() =>
                  navigate(
                    `/helping_videos_category/helping-videos/${value._id}`,
                    {
                      state: value,
                    },
                  )
                }
              >
                <img
                  src={s3baseUrl + value?.image?.thumbnail_1}
                  className="card-img-top pods-image"
                  alt="Programme"
                />
                <div className="card-body">
                  <div className="row">
                    <div className="col-12">
                      <h3 className="h2-heading">{value.title}</h3>
                    </div>

                    <div className="col-2 menu-option"></div>
                  </div>
                  <p className="programme-card-desc">{value.description}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
